<main>
    <!-- *** LOADING SPINNER ***
        Progress Spinner while function config is loading
    -->
    <div *ngIf="this.functionConfigLoaded == false" class="header">
        <button mat-icon-button color="primary" class="back-button" routerLink="/machineState/graph-equipment">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <mat-progress-spinner mode="indeterminate" color="primary" diameter="80"></mat-progress-spinner>
        <div><!--EMPTY--></div>
    </div>

    <!-- CARD
        *CARDCARD 
    -->

    <!-- TITLE -->
    <mat-card class="m-auto padding12 home-card boxshadowgrey" *ngIf="this.functionConfigLoaded == true">
        <div>
            <button mat-icon-button color="primary" class="back-button" routerLink="/machineState/graph-equipment">
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>
        <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <mat-card-title> {{ 'MASCHINESTATE.GRAPH.HEADER' | translate}} {{ this.functionConfig?.name }}</mat-card-title>
            <mat-card-subtitle>{{ 'MASCHINESTATE.GRAPH.SUBTITLE' | translate}}</mat-card-subtitle>

        </mat-card-title-group>

        <!-- CONTROL BAR -->
        <mat-card-content>
            <div class="function-view-content" id="query-control">
                <app-query-control-bar class="component" id="querycontrols" (queryStarted)="queryStarted($event)"></app-query-control-bar>
            </div>

            <!-- GRAPH -->
            <div class="function-view-content" id="graph">
                <app-basic-view-graph
                    [rawDataset]="this.rawDataSet"
                    [functionConfig]="this.functionConfig"
                    [dataIdentifiersToDisplay]="this.graphDataIdentifierToDisplay"
                    [queryStarted]="this.started"
                ></app-basic-view-graph>
            </div>

            <!-- TABLE -->
            <div class="function-view-content" id="table">
                <app-basic-view-table
                    [rawDataset]="this.rawDataSet"
                    [functionConfig]="this.functionConfig"
                    (dataSelected)="dataSelected($event)"
                ></app-basic-view-table>
            </div>
        </mat-card-content>
    </div>
    </mat-card>
    <!-- *** CONTENT ***
        Display content as soon as function config is loaded
    -->